import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ListaFabricanteResponse } from '../../responses/repositorio-tintas/lista-fabricante.response';
import { FabricanteRequest } from '../../requests/repositorio-tintas/fabricante.request';
import { FabricanteResponse } from '../../responses/repositorio-tintas/fabricante.response';

@Injectable({
  providedIn: 'root',
})
export class FabricanteService extends CommonService {
  constructor(private httpClient: HttpClient) {
    super();
  }

  public listaFabricante(nomeFabricante: string, paginaAtual: number): Observable<ListaFabricanteResponse> {
    const uri: string = `fabricante/listaFabricante?nomeFabricante=${nomeFabricante}&paginaAtual=${paginaAtual}`;

    return this.httpClient
      .get<ListaFabricanteResponse>(environment.urlApiRepositorioTintas + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public ObterPorId(idFabricante: number): Observable<FabricanteResponse> {
    return this.httpClient
      .get<FabricanteResponse>(
        environment.urlApiRepositorioTintas + `fabricante/idFabricante/${idFabricante}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public Alterar(idFabricante: number, fabricanteRequest: FabricanteRequest): Observable<FabricanteResponse> {
    const formData = new FormData();

    Object.keys(fabricanteRequest).forEach(key => {
      const value = (fabricanteRequest as any)[key];
      formData.append(key, value);
    });

    return this.httpClient
      .put<FabricanteResponse>(
        environment.urlApiRepositorioTintas + `fabricante/idFabricante/${idFabricante}`,
        formData,
        this.addToken()
      )
      .pipe(catchError(this.handleError));
  }
}
